

























import { Component, Vue, Prop } from 'vue-property-decorator';
import HolderForm from '@/components/ProductVariantHolder/HolderForm.vue';
import { productVariantHolderFragments } from '@/queries/ProductVariantHolderFragments';
import { GQL_updateProductVariantHolderVariables } from '@/queries/__generated__/updateProductVariantHolder';
import { GQL_ProductVariantHolderUpdate } from '@/queries/global';
import SPopup from '@/components/UI/Popup/SPopup.vue';
import gql from 'graphql-tag';

const GET_PRODUCT_VARIANT_HOLDER = gql`
  query productVariantHolder($id: ID!) {
    productVariantHolder(id: $id) {
      ...productVariantHolderFragments,
    }
  },
  ${productVariantHolderFragments}
`;

const UPDATE_PRODUCT_VARIANT_HOLDER = gql`
  mutation updateProductVariantHolder($productVariantHolder: ProductVariantHolderUpdate!) {
    updateProductVariantHolder(input: { productVariantHolder: $productVariantHolder }) {
      productVariantHolder {
        ...productVariantHolderFragments
      }
    },
  },
  ${productVariantHolderFragments}
`;

@Component({
  components: {
    HolderForm,
  },
})
export default class HolderEdit extends Vue {
  @Prop([ Number, String ]) private id!: number | string;
  private GET_PRODUCT_VARIANT_HOLDER = GET_PRODUCT_VARIANT_HOLDER;
  private UPDATE_PRODUCT_VARIANT_HOLDER = UPDATE_PRODUCT_VARIANT_HOLDER;

  @Prop() private parentPopup!: SPopup

  public formatDataForMutation(productVariantHolder: GQL_ProductVariantHolderUpdate): GQL_updateProductVariantHolderVariables {
    return {
      productVariantHolder: {
        id: productVariantHolder.id,
        name: productVariantHolder.name,
        attributeName: productVariantHolder.attributeName,
        description: productVariantHolder.description,
        variants: productVariantHolder.variants!.map((variant) => {
          return {
            id: variant.id,
            name: variant.name,
            productId: variant.productId,
            _destroy: variant._destroy,
          };
        }),
      },
    };
  }
}
